import React, { useContext } from 'react'
import { MakeRequestContext } from '../../MakeRequestContext'
import CardStep from '../../../../../components/modalStepper/step/CardStep'
import classNames from 'classnames'
import { FormattedMessage } from 'react-intl'
import { makeStyles, useTheme } from '@material-ui/core/styles'
import styles from '../../../../../styles'
import { makeRequestTypes } from '../../../../../enums/makeRequestEnum'
import { ClassValue } from 'classnames/types'
import { useMediaQuery } from 'react-responsive'
import { propertyType, requestType } from '../../../../../enums/contractsEnum'
import SvgTechnical from '../../../../../icons/Technical'
import SvgAdministrative from '../../../../../icons/Administrative'
import { saveInteractions } from '../../../../gtm/utils/gtmCallback'
import fr from '../../../../../translations/fr'

const useStyle = makeStyles(
	(theme) => (
		{
			...styles(theme),
			cardContainerStyle: {
				width: '100%',
				margin: 0
			}
		}
	)
)

const RequestType = () => {
	const classes = useStyle()
	const theme = useTheme()
	const { request, nextStep } = useContext(MakeRequestContext)
	const isLargeScreen = useMediaQuery(
		{
			query: '(min-width: 1025px)'
		}
	)

	const cardContainerClass: ClassValue = classNames(
		'row',
		{
			[classes.cardContainerStyle]: !isLargeScreen
		}
	)

	const getBlocDescription = (card: string) => {
		const cardTypeClass = classNames(
			classes.text7
		)

		return (
			<>
				<h2 className={cardTypeClass}>
					<FormattedMessage
						id={`requests.makeRequest.step1.${card}`}
						defaultMessage={card}
						description="Card description"
					/>
				</h2>
			</>
		)
	}

	const getImg = (card: string) => {
		if (card === requestType.technical) {
			return <SvgTechnical color={theme.palette.blue.main} width={50} height={50}/>
		}
		else if (card === requestType.administrative) {
			return <SvgAdministrative color={theme.palette.blue.main} width={50} height={50} />
		}
	}

	const updateRequestType = (text: string) => {
		request.requestType = text

		saveInteractions(
			{
				category: 'Vos Demandes',
				action: 'Déposer une demande',
				// @ts-ignore
				label: `Etape 2::Bien concerné::${request.contract?.type === propertyType.apartment ? 'Appartement' : 'Parking'}::${fr[`requests.makeRequest.step1.${text}`]}`
			}
		)

		nextStep()
	}

	return (
		<div className={cardContainerClass}>
			{
				Object.getOwnPropertyNames(makeRequestTypes).map(
					(card) => (
						<CardStep
							key={card}
							blocDescription={getBlocDescription(card)}
							img={getImg(card)}
							setSelected={() => updateRequestType(card)}
						/>
					)
				)
			}
		</div>
	)
}

export default RequestType